import * as types from './types';

export function moveToBudgetLineItemSuccess(id) {
	return { type: types.MOVE_TO_BUDGET_ITEM_SUCCESS, id }
}

export function saveSuccess(details) {
	return { type: types.SAVE_DETAILS_SUCCESS, details }
}

export function moveToLineItem(item) {
	return function (dispatch) {
		dispatch(moveToBudgetLineItemSuccess(item));
	}
}

export function save(user) {
	return function (dispatch) {
		dispatch(saveSuccess(user));
	}
}



// WEBPACK FOOTER //
// ./src/actions/mandatoriesActions.js